import _ from 'underscore';
import $ from 'jquery';
import 'jquery.redirect';
import instrument from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentConsts from '@bingads-webui-static-legacy/instrumentation/constants';
import BulkDeleteLightbox from './bulk-delete-lightbox';
import BulkReactivateABLMisssingLightbox from './bulk-reactivate-abl-missing-lightbox';
import { getCCUrl } from '@bingads-webui-component-legacy/bingads-grid/shared/clientcenter-url-helper';
import { AccountHoldStatus, AccountInactiveReasons } from './constants';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/bulk-action-accounts-grid');

const alertCenter = window.App.views.alertCenter;

const postRequestWithErrorHandled = ({ url, data, successCallback, logMethodName })  => {
  $.advertiser.ajaxPost({
    url,
    xhrFields: {
      withCredentials: true,
    },
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify(data),
    onSuccess: (response) => {
      if (response) {
        if (response.IsSuccess === true) {
          successCallback(response);
        } else {
          // else: Error messages from a onSuccess ajax call are handled in $.advertiser.ajaxPost, so no need to display them to the user at this moment
          instrument.logMessage(instrumentConsts.LOGCATEGORY.INFO, instrumentConsts.LOGLEVEL.INFO, logMethodName, `response with errors. query parameters: ${JSON.stringify(data)}, response: ${JSON.stringify(response)}`);
        }
      } else {
        alertCenter.showWarning(i18n.getString('GenericErrorMessage_Short'));
        instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, logMethodName, `response empty: ${JSON.stringify(data)}`);
      }
    },
    onError: (e) => {
      alertCenter.showWarning(i18n.getString('GenericErrorMessage_Short'));
      instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, logMethodName, `response/ajaxPost failed with ${JSON.stringify(e)}`);
    },
    hideLoadingPanelOnSuccess: true,
  });
};

const handleErrorMessage = (errors, logMethodName, data) => {
  let firstError = _.first(errors);

  if (!_.isEmpty(firstError)) {
    let errorCodes = _.map(errors, (error) => error.Code);

    instrument.logMessage(instrumentConsts.LOGCATEGORY.INFO, instrumentConsts.LOGLEVEL.INFO, logMethodName,
      `response with errors. query parameters: ${JSON.stringify(data)}, response: Error codes = ${JSON.stringify(errorCodes)}`);
    return firstError.Message;
  }

  return firstError;
};

const postRequestWithBatchErrorHandled = ({ url, data, successCallback, logMethodName })  => {
  $.advertiser.ajaxPost({
    url,
    xhrFields: {
      withCredentials: true,
    },
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify(data),
    onSuccess: (responses) => {
      if (responses) {
        _.each(responses, (response) => {
          const { Value: { IsSuccess: isSuccess, InternalErrors, SenderErrors } = {} } = response;
          const isAccountAlreadyHoldOrUnHold = _.isEmpty(InternalErrors) && _.all(SenderErrors, (error) => error.Code === AccountHoldStatus.AccountHoldStatusInvalid);

          if (isSuccess || isAccountAlreadyHoldOrUnHold) {
            successCallback(data);
          } else {
            let showWarning;

            showWarning = handleErrorMessage(InternalErrors, logMethodName, data);
            showWarning = handleErrorMessage(SenderErrors, logMethodName, data);
            if (_.isEmpty(showWarning)) {
              alertCenter.showWarning(i18n.getString('GenericErrorMessage_Short'));
            } else {
              alertCenter.showWarning(showWarning);
            }
          }
        });
      } else {
        alertCenter.showWarning(i18n.getString('GenericErrorMessage_Short'));
        instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, logMethodName, `response empty: ${JSON.stringify(data)}`);
      }
    },
    onError: (e) => {
      alertCenter.showWarning(i18n.getString('GenericErrorMessage_Short'));
      instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, logMethodName, `response/ajaxPost failed with ${JSON.stringify(e)}`);
    },
    hideLoadingPanelOnSuccess: true,
  });
};

const fetchAccountsData = (accountIds, successCallback) => {
  $.advertiser.ajaxGet({
    url: getCCUrl('api/account', { accountIds }),
    xhrFields: {
      withCredentials: true,
    },
    contentType: 'application/json',
    dataType: 'json',
    onSuccess: (response) => {
      if (response) {
        successCallback(response.value);
      }
    },
    hideLoadingPanelOnSuccess: true,
  });
};

const postRequestRedirect = (url, data) => {
  $.redirect(url, data);
};

export function bulkEditAbl({selectedAccounts, customerId, userId}) {
  const bulkEditTaxesValidationErrorsSegments = 'accounts/BulkEditTaxesValidationErrors';
  const accountsUpdateSegments = 'accounts/update';
  const logMethodName = 'BulkEditTaxesValidationErrors';

  const data = {
    cid: customerId,
    uid: userId,
    accountIds: _.pluck(selectedAccounts, 'Id'),
  };

  const bulkEditTaxesValidationErrorsUrl = getCCUrl(bulkEditTaxesValidationErrorsSegments);
  const accountsUpdateUrl = getCCUrl(accountsUpdateSegments, _.pick(data, 'cid', 'uid'));

  postRequestWithErrorHandled({
    url: bulkEditTaxesValidationErrorsUrl,
    data,
    successCallback: () => {
      postRequestRedirect(accountsUpdateUrl, data);
    },
    logMethodName,
  });
}

export function bulkEditManualHold({selectedAccounts, isApplyHold, successCallback }) {
  const bulkEditManualHoldSegments = 'accounts/BatchAccountManualHold';
  const logMethodName = 'BatchAccountManualHold';

  const data = {
    accountIds: _.pluck(selectedAccounts, 'Id'),
    isApplyHold,
  };
  const bulkEditManualHoldUrl = getCCUrl(bulkEditManualHoldSegments, data);

  postRequestWithBatchErrorHandled({
    url: bulkEditManualHoldUrl,
    data,
    successCallback,
    logMethodName,
  });
}

export function bulkDeleteAccounts({selectedAccounts, successCallback}) {
  const accountsDeleteSegments = 'accounts/Delete';
  const logMethodName = 'bulkDeleteAccounts';

  const data = {
    accountIds: _.pluck(selectedAccounts, 'Id'),
  };
  const accountsDeleteUrl = getCCUrl(accountsDeleteSegments);

  if (data.accountIds && data.accountIds.length) {
    const dialogView = new BulkDeleteLightbox({
      accountsCount: data.accountIds.length,
      proceedButtonClickCallback: () => {
        postRequestWithErrorHandled({
          url: accountsDeleteUrl,
          data,
          successCallback,
          logMethodName,
        });
      },
    });

    dialogView.render();
  }
}

export function bulkReactivateAccounts({i18n: newI18n, selectedAccounts, successCallback}) {
  const accountsReactivateSegments = 'accounts/Reactivate';
  const logMethodName = 'bulkReactivateAccounts';
  const getABLMissingAccounts = (accounts) => _.filter(accounts, (account) => {
    const accountInactiveReasons = _.get(account, 'AccountInactiveReasonsV1', []);

    return Array.isArray(accountInactiveReasons) && accountInactiveReasons.some((reason) => reason.Reason === AccountInactiveReasons.AccountMissingABL);
  });
  const selectedAccountIds = _.pluck(selectedAccounts, 'Id');
  const data = {
    accountIds: selectedAccountIds,
  };
  const accountsReactivateUrl = getCCUrl(accountsReactivateSegments);

  postRequestWithErrorHandled({
    url: accountsReactivateUrl,
    data,
    successCallback: () => {
      fetchAccountsData(selectedAccountIds, (accounts) => {
        const ABLMissingAccounts = getABLMissingAccounts(accounts);

        if (ABLMissingAccounts.length) {
          const ABLMissingAlertView = new BulkReactivateABLMisssingLightbox({
            i18n: newI18n,
            accountNumbers: _.pluck(ABLMissingAccounts, 'Number'),
            onAction: successCallback,
          });

          ABLMissingAlertView.render();
        } else {
          successCallback();
        }
      });
    },
    logMethodName,
  });
}
